import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
standalone: false,
  selector: 'app-topup-icon',
  templateUrl: './topup-icon.component.html',
  styleUrls: ['./topup-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopupIconComponent {
  @Input() public sizeDollar: number;
  @Input() public sizeSmartphone: number;
}
